// extracted by mini-css-extract-plugin
export const section = "cardCandidate-module--section--b8eaA";
export const container = "cardCandidate-module--container--1XTUq";
export const pageContent = "cardCandidate-module--pageContent--152d5";
export const footer = "cardCandidate-module--footer--17t9r";
export const modal = "cardCandidate-module--modal--3of4x";
export const card = "cardCandidate-module--card--3Q2Ms";
export const image = "cardCandidate-module--image--pqmU4";
export const title = "cardCandidate-module--title--21o3Z";
export const videoWrap = "cardCandidate-module--videoWrap--1-7tC";